import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import s from '../MainImage/MainImage.module.css';
import { updateInventoryPhoto } from '../../../store/slices/boardSlice';

const ImagePlaceholder = ({
    previewUrl,
    inventoryGuid,
    setNewInventoryLog,
    setInventoryData,
    inventoryData,
    warehouseId,
    setImage,
}) => {
    const dispatch = useDispatch();
    const [errors, setErrors] = useState('');
    const maxFiles = 10;

    const loadPhotos = (photos) => {
        const formData = new FormData();
        photos.forEach((photo) => {
            formData.append('files[]', photo);
        });

        const url = helpable.replaceUrlParameters(routable.getRoute('uploadInventoryPhotos'), {
            _guid_: inventoryGuid,
        });
        fetch(url, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                setNewInventoryLog(data.response);
                setInventoryData({
                    ...inventoryData,
                    // eslint-disable-next-line camelcase
                    preview_url: data.response.photos[data.response.photos.length - 1].original_url,
                });
                setImage(data.response.photos[data.response.photos.length - 1].original_url);
                if (!inventoryData.preview_url) {
                    setInventoryData({
                        ...inventoryData,
                        // eslint-disable-next-line camelcase
                        preview_url: data.response.photos[0].original_url,
                    });
                    dispatch(
                        updateInventoryPhoto({
                            preview: data.response.photos[0].original_url,
                            warehouseId,
                            inventoryGuid,
                        })
                    );
                }
            })
            .catch((e) => {
                console.log('e', e);
            });
    };

    const onInputChange = (event) => {
        const images = event.currentTarget.files;

        const isSizeError = Object.values(images).some((image) => image.size >= 5242880);
        const correctFormat = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        const isNotCorrectFormat = Object.values(images).some(
            (image) => correctFormat.includes(image.type) === false
        );
        if (Object.values(images).length > maxFiles) {
            setErrors(
                i18next.t('imagePlaceholder.onInputChange.errors.amount_limit_first')
                + ' 10 '
                + i18next.t('imagePlaceholder.onInputChange.errors.amount_limit_second')
            );
        } else if (isSizeError) {
            setErrors(
                i18next.t('imagePlaceholder.onInputChange.errors.size_limit_first')
                + ' 5 '
                + i18next.t('imagePlaceholder.onInputChange.errors.size_limit_second')
            );
        } else if (isNotCorrectFormat) {
            setErrors(
                i18next.t('imagePlaceholder.onInputChange.errors.invalid_format')
                + ' (jpeg, jpg, png, gif)'
            );
        } else {
            setErrors('');
            loadPhotos(Object.values(images));
        }
    };

    return (
        <>
            {previewUrl === null && (
                <>
                    <input
                        accept="image/*"
                        id="file-input"
                        type="file"
                        name="file"
                        multiple
                        onChange={onInputChange}
                    />
                    <label
                        htmlFor="file-input"
                        className={cx(s.inventoryPhoto, s.placeholder, { [s.red]: !!errors })}
                    >
                        <div className={cx(s.addPhoto)}>
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13.1562 4.40625H10.8125V3.46875H4.95312V4.40625H2.60938C2.27785 4.40625 1.95991 4.53795 1.72549 4.77237C1.49107 5.00679 1.35938 5.32473 1.35938 5.65625V12.1406C1.35938 12.4721 1.49107 12.7901 1.72549 13.0245C1.95991 13.2589 2.27785 13.3906 2.60938 13.3906H13.1562C13.4878 13.3906 13.8057 13.2589 14.0401 13.0245C14.2746 12.7901 14.4062 12.4721 14.4062 12.1406V5.65625C14.4062 5.32473 14.2746 5.00679 14.0401 4.77237C13.8057 4.53795 13.4878 4.40625 13.1562 4.40625ZM7.8825 12.6875C5.79375 12.6875 4.095 10.9875 4.095 8.89875C4.095 6.81 5.79375 5.11 7.8825 5.11C9.97125 5.11 11.6713 6.81 11.6713 8.89875C11.6713 10.9875 9.97125 12.6862 7.8825 12.6862V12.6875ZM7.8825 6.35938C7.54898 6.35942 7.21874 6.42515 6.91063 6.55282C6.60251 6.68049 6.32256 6.86759 6.08676 7.10345C5.85096 7.33931 5.66392 7.61931 5.53633 7.92745C5.40873 8.2356 5.34308 8.56586 5.34312 8.89937C5.34317 9.23289 5.4089 9.56313 5.53657 9.87125C5.66424 10.1794 5.85134 10.4593 6.0872 10.6951C6.32306 10.9309 6.60306 11.118 6.9112 11.2455C7.21935 11.3731 7.54961 11.4388 7.88312 11.4388C8.55677 11.4387 9.2028 11.171 9.67908 10.6946C10.1554 10.2182 10.4229 9.57209 10.4228 8.89844C10.4227 8.22479 10.155 7.57876 9.67864 7.10248C9.20224 6.62619 8.55615 6.35867 7.8825 6.35875V6.35938Z"
                                    fill="white"
                                />
                            </svg>
                            {i18next.t('imagePlaceholder.return')}
                        </div>
                    </label>
                    {!!errors && <div className={cx(s.textError)}>{errors}</div>}
                </>
            )}
        </>
    );
};

export default ImagePlaceholder;
